/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react';
import { Box, Button, Grid, Typography } from '@mui/material';
import './YearMonthFilterCard.css';
import { themes, fonts } from '../../themes/themes';
import YearFilterButton from '../YearFilterButton/YearFilterButton';
import { DatePickerInput } from '../../../components';
import moment from 'moment';
import { defaultDateFormatting } from '../../helper';
import { useAppSelector } from '../../../infra/hooks';
import { commonServices } from '../../../api/services/commonServices';
import toast from 'react-hot-toast';

interface IYearFilterCardProps {
  card_title?: string;
  card_height?: string;
  child_height?: any;
  yearTitle: any;
  yearMenu: any;
  padding?: string;
  fromDate: (data: any) => void;
  toDate: (data: any) => void;
  trans: any;
  ExportAll?: any;
  from?: any;
  to?: any;
}

const DateFilterCard: React.FC<
  React.PropsWithChildren<IYearFilterCardProps>
> = ({
  children,
  card_title,
  card_height,
  child_height,
  yearMenu,
  yearTitle,
  padding,
  fromDate,
  toDate,
  from, 
  to,
  trans,
  ExportAll,
}) => {
  const [fromdate, setFromDate] = useState<any>(
   from ?? moment(new Date()).format(defaultDateFormatting),
  );
  const [todate, setToDate] = useState<any>(
   to ?? moment(new Date()).endOf('month').format(defaultDateFormatting),
  );
  const selector = useAppSelector((state) => state.authSlice);
  const exportAll = async (event: string) => {
    const user_id = selector.user_id;
    const company_id = selector.company_id;
    const emp_id = selector.emp_id;
    const ExportAllResponse: any = await commonServices.exportAll({
      event: event,
      user_id: user_id,
      company_id: company_id,
      emp_id: emp_id,
      from_date: fromdate,
      to_date: todate,
    });
    if (ExportAllResponse?.response == 'success') {
      toast.success(trans('Your request is queued'));
    }
  };
  return (
    <Box
      className="year_filter_card"
      style={{
        maxHeight: card_height,
        height: 'auto',
        padding,
      }}
    >
      <Grid container>
        <Grid
          item
          xs={12}
          style={{
            display: 'flex',
            flexDirection: 'row',
          }}
        >
          <Grid
            item
            xs={9}
            style={{
              justifyContent: 'right',
            }}
          >
            <Typography
              style={{
                color: themes.blackDefault,
                fontSize: fonts.header,
                fontFamily: fonts.fontFamily,
                fontWeight: 'bold',
              }}
            >
              {card_title}
            </Typography>
          </Grid>
          <Grid
            item
            xs={5}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginRight: '10px', // Add margin for space
              backgroundColor: '#7C0E6F1A',
              borderRadius: '8px',
              borderStyle: 'dashed',
              borderWidth: '1px',
              borderColor: '#7C0E6F',
            }}
          >
            <Button
              className="export-button2"
              startIcon={<i className="las la-file-export"></i>}
              onClick={() => exportAll(ExportAll)}
              style={{ color: '#7C0E6F' }}
            >
              {trans('Export All')}
            </Button>
          </Grid>
          <Grid
            item
            xs={5}
            style={{
              display: 'flex',
              alignItems: 'flex-end',
              justifyContent: 'flex-end',
              marginRight: '10px', // Add margin for space
            }}
          >
            <DatePickerInput
              width="100%"
              label={trans('From Date')}
              defaultValue={from}
              value={fromdate}
              supportUTC={false}
              onChange={(newValue: any) => {
                const formattedDate = moment(newValue).format(
                  defaultDateFormatting,
                );
                fromDate(formattedDate);
                setFromDate(formattedDate);
              }}
            />
          </Grid>
          <Grid
            item
            xs={5}
            style={{
              display: 'flex',
              alignItems: 'flex-end',
              justifyContent: 'flex-end',
            }}
          >
            <DatePickerInput
              width="100%"
              label={trans('To Date')}
              minDate={fromdate}
              supportUTC={false}
              onChange={(newValue: any) => {
                const formattedtoDate = moment(newValue).format(
                  defaultDateFormatting,
                );
                toDate(formattedtoDate);
                setToDate(formattedtoDate);
              }}
            />
          </Grid>
        </Grid>
      </Grid>

      <Box
        style={{
          marginTop: '0.5em',
          paddingBottom: '5px',
          overflowY: 'auto',
          height: 'auto',
          maxHeight: child_height,
        }}
      >
        {children}
      </Box>
    </Box>
  );
};

export default DateFilterCard;
